import { styled } from 'styled-components';
import Media from '@dvd/components/Media';
import SocialProof from '@dvd/modules/SocialProof';
import * as Styled from '@lib/styles';
import { ReactNode } from 'react';

// Per design we don't want any bottom margin on the messaging
export const HeroMessaging = styled.div`
  text-align: center;

  & > p {
    margin-block-end: 0;
  }
`;

export const HeroMedia = styled(Media)`
  margin-block-start: ${({ theme }) => theme.spacing[3]};
  margin-block-end: 0;

  ${({ theme }) => theme.mq.minWidth.large} {
    margin-block-start: ${({ theme }) => theme.spacing[4]};
  }
`;

export const HeroLogos = styled(SocialProof)`
  padding-block-end: 0;
  margin-block-start: ${({ theme }) => theme.spacing[1]};

  ${({ theme }) => theme.mq.minWidth.large} {
    margin-block-start: ${({ theme }) => theme.spacing[4]};
  }
`;

export const HeroSubtitle = styled.p`
  font-family: var(--font-walsheim);
  font-size: ${({ theme }) => theme.typography.fontSize.headingOne};
  font-weight: ${({ theme }) => theme.typography.fontWeight.headingOne};
  line-height: ${({ theme }) => theme.typography.lineHeight.headingOne};
  text-wrap: balance;

  ${({ theme }) => theme.mq.minWidth.large} {
    font-size: ${({ theme }) => theme.typography.fontSize.desktop.headingOne};
  }
`;

const HeroDescriptionWrapper = styled(Styled.BodyLg)`
  text-wrap: balance;

  &.longDescription {
    /* Remove bottom margin from last element when HTML is used for description. */
    :last-child {
      margin-block-end: 0;
    }
  }
`;

export const HeroDescription = ({
  description,
}: {
  description: ReactNode | string;
}) => {
  const descriptionIsString = typeof description === 'string';

  return (
    <>
      {descriptionIsString ? (
        <HeroDescriptionWrapper as="p">{description}</HeroDescriptionWrapper>
      ) : (
        <HeroDescriptionWrapper as="div" className="longDescription">
          {description}
        </HeroDescriptionWrapper>
      )}
    </>
  );
};

export const HeroComputedMedia = ({
  hashedId,
  imageSrc,
  imageAlt,
  variant,
  aspect,
}) => {
  const { computedHeight, computedWidth } =
    variant === 'portrait'
      ? { computedHeight: 528, computedWidth: 704 }
      : { computedHeight: 613, computedWidth: 1088 };
  if (hashedId) {
    return <HeroMedia hashedId={hashedId} aspect={aspect} />;
  }
  if (imageSrc) {
    return (
      <HeroMedia
        alt={imageAlt}
        height={computedHeight}
        src={imageSrc}
        width={computedWidth}
      />
    );
  }
  return null;
};
